<template>
  <div class="map-page-wrapper">
    <van-nav-bar
      :left-text="infoData.name"
      left-arrow
      fixed
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <section class="map-content">
      <img :src="infoData.map_image" alt="" class="map-img">
    </section>
    <section class="form-content">
      <div class="site-place flex justify-between">
        <div class="from-site">
          <div class="name">上车站点</div>
          <div class="site-info">
            <div class="site-time">{{ infoData.origin_time }}</div>
            <div class="site-name">{{ infoData.origin_address }}</div>
          </div>
        </div>
        <div class="middle-site center column">
          <img src="../assets/images/site.png" alt="" class="site-img">
          <div class="middle-site-label">
            中间站点
          </div>
        </div>
        <div class="to-site">
          <div class="name align-right">下车站点</div>
          <div class="site-info">
            <div class="site-time align-right">{{ infoData.end_time }}</div>
            <div class="site-name align-right">{{ infoData.end_address }}</div>
          </div>
        </div>
      </div>
      <div class="display-sites flex">
        <div class="site-item site-start">
          <div class="site-label">
            <span class="label-text">上</span>
          </div>
          <div class="site-time">
            {{ infoData.origin_time }}
          </div>
          <div class="site-name">
            {{ infoData.origin_address }}
          </div>
        </div>
        <div class="middle-sites-wrapper flex" v-if="interSites.length > 0">
          <div class="site-item" v-for="(item, index) in interSites" :key="index">
            <div class="site-label middle-site-arrow">
              <van-icon name="arrow" />
            </div>
            <div class="site-time">
              {{ item.end_time }}
            </div>
            <div class="site-name">
              {{ item.site_name }}
            </div>
          </div>
        </div>
        <div class="site-item site-end">
          <div class="site-label">
            <span class="label-text">下</span>
          </div>
          <div class="site-time align-center">
            {{ infoData.end_time }}
          </div>
          <div class="site-name align-center">
            {{ infoData.end_address }}
          </div>
        </div>
      </div>

      <div class="button-wrapper">
        <van-button type="primary" class="buy-ticket-button" @click="buyTicket">
          <span>￥</span> {{ price }} 立即预约
        </van-button>
      </div>
    </section>
  </div>
</template>

<script>
import Trains from '@/apis/Trains';

export default {
  name: 'Map',
  data() {
    return {
      infoData: {},
    };
  },
  created() {
    this.queryData();
  },
  computed: {
    interSites() {
      if (this.infoData?.intermediate_site) {
        return JSON.parse(this.infoData.intermediate_site);
      }
      return []; // 空列表
    },
    userId() {
      return this.$store.getters['auth/userId'];
    },
    price() {
      // if (this.userId) {
      //   const firstLetter = this.userId.slice(0, 1);
      //   const studentStartLetter = ['1', '2', '3', '5'];
      //   if (studentStartLetter.indexOf(firstLetter) > -1) {
      //     return this.infoData?.student_ticket_price;
      //   }
      //   return this.infoData.teacher_ticket_price;
      // }
      // return '';
      return this.$route.query?.price || 0.00;
    },
  },
  methods: {
    async queryData() {
      const { id } = this.$route.query;
      const res = await Trains.getInfo({ id });
      this.infoData = res?.data;
    },
    onClickLeft() {
      this.$router.back();
    },
    onClickRight() {
      console.log('click on right');
    },
    buyTicket() {
      this.$router.push({
        path: '/choose',
        query: {
          id: this.$route.query.id,
          shuttleType: this.$route.query.shuttleType,
          serviceTime: this.$route.query.service_time,
          originTime: this.$route.query.originTime,
          price: this.price,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variable.scss";
@import "~@/assets/styles/mixins.scss";

.map-page-wrapper {
  max-width: 100vw;
  overflow: hidden;
}
::v-deep {
  .van-nav-bar .van-icon {
    font-size: 18px;
    color: #000;
  }
  .van-hairline {
    &:after {
      border: none!important;
    }
  }
}

::v-deep {
  .van-nav-bar {
    background: transparent!important;
  }
}
.map-content {
}
.map-img {
  width: 100%;
}
.site-img {
  width: 20px;
}
.form-content {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 400px;
  background: #fff;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  box-sizing: border-box;
  padding: 15px;
  color: #2d2d2d;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  @include safe-padding-bottom(15px);
}

.from-site, .to-site {
  .name {
    color: #2d2d2d;
    font-size: 12px;
    margin-bottom: 12px;
  }
}

.site-info {
  font-weight: bold;
  font-size: 18px;
}
.site-place {
  flex-shrink: 0;
  position: relative;
  .to-site {
    padding-left: 4.28rem;
  }
  .from-site {
    padding-right: 1.4rem;
  }
}
.middle-site {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
}

.middle-site-label {
  margin-top: 5px;
}

.button-wrapper {
  flex-shrink: 0;
  .buy-ticket-button {
    width: 100%;
    border-radius: 4px;
    background-color: $brand-color;
    border-color: $brand-color;
  }
}

.display-sites {
  flex-grow: 1;
  position: relative;
  box-sizing: border-box;
  margin-top: 1.24rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 1rem;
  overflow-x: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

.site-line-dot {
  position: absolute;
  width: 100%;
  height: 2px;
  border-bottom: 1px dashed #eee;
}

.site-item {
  flex-basis: 0;
  flex-grow: 0;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: center;
  margin-right: 1.428rem;
  &.site-start {
    color: #ff9954;
    .site-label {
    }
  }
  &.site-end {
    margin-right: 0;
    color: #1abefb;
    .site-label {
      background-color: #1abefb;
    }
  }
  .site-label {
    width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: #fff;
    background: #ff9954;
    border-radius: 50%;
    text-align: center;
    .label-text {
      display: inline-block;
      transform: scale(0.8);
    }
  }
  .site-time {
    margin-top: 10px;
    margin-bottom: 5px;
  }
  .site-name {
    max-width: 40px;
    writing-mode: vertical-lr;
    -webkit-writing-mode: vertical-lr;
    //-ms-writing-mode: vertical-lr;
    text-align: start;
  }
}

.middle-site-arrow {
  transform: scale(0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #cdcdcd!important;
  color: #4d4d4d!important;
  font-family: Sans-serif;
  font-weight: bold;
}
</style>
